module.exports = __webpack_public_path__ + "static/media/graphic-design.7482d8e2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/graphic-design.svg
// module id = 321
// module chunks = 0